<script>
import { saveAs } from 'file-saver/FileSaver'
import { toArrayBuffer, formatDate } from 'src/utils'
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  name: "UserWizardRoles",
  props: {
    validation: {}
  },
  data() {
    return {
      currentStep: 1,
    };
  },
  computed: {
    ...mapState('users', {
      open: (state) => state.userWizardModal.open,
      maximized: (state) => state.userWizardModal.maximized,
      isAffiliate: (state) => state.affiliateForm.ACTIVE_IND,
      isInstructor: (state) => state.instructorForm.ACTIVE_IND,
      isRecruiter: (state) => state.recruiterForm.ACTIVE_IND,
      isManager: (state) => state.managerForm.ACTIVE_IND,
      isAdministrator: (state) => state.administratorForm.ACTIVE_IND,
      invalidUserRoles: s=> s.userWizardModal.invalidUserRoles
    })
  },
  methods: {
    ...mapMutations(["closeModal"]),
    ...mapMutations("users", [
      "closeUserWizardModal", 
      'updateAdministratorForm', 
      'updateManagerForm', 
      'updateRecruiterForm', 
      'updateAffiliateForm', 
      'updateInstructorForm',
      'setInvalidUserRoles'
    ]),
    ...mapActions("reports", [ "generateRecruiterReferral"]),
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    setForm(value){
      let vm = this
      let hasAnyRoles = ( (vm.isAffiliate || vm.isInstructor || vm.isRecruiter || vm.isManager || vm.isAdministrator) )
      if(hasAnyRoles) vm.setInvalidUserRoles(false)
      else vm.setInvalidUserRoles(true)

    }
  }
};
</script>

<template>
<div class="relative-position layout-padding" >
  <div class="text-center q-pb-lg">
    <h6>Please select any roles this user may have:</h6>
    <transition name="bounce">
      <p v-if="invalidUserRoles" style="margin-top:20px" class="text-red"><q-icon name="info outline" color="red" size="20px" /> Must choose at least <b>one</b> role. </p>
    </transition>
  </div>
  <div class="center">
    <q-list link style="padding: 0" class="round">
      <q-item tag="label" separator v-if="$p(['ADMIN','MANAGER','AFFILIATE'],'or')">
        <q-item-side>
          <q-icon size="30px" color="primary" name="fa fa-graduation-cap"></q-icon>
        </q-item-side>
        <q-item-main>
          <q-item-tile title>Instructor</q-item-tile>
        </q-item-main>
        <q-item-side>
          <q-field>
            <q-checkbox :value="isInstructor" @input="(value) => { updateInstructorForm({ field: 'ACTIVE_IND', value }); setForm(value); }" />
          </q-field>
        </q-item-side>
      </q-item>
      <q-item tag="label" separator v-if="$p(['ADMIN','MANAGER','RECRUITER'],'or')">
        <q-item-side>
          <q-icon size="30px" color="primary" name="fa fa-building"></q-icon>
        </q-item-side>
        <q-item-main>
          <q-item-tile title>
            Affiliate 
            <span v-if="isRecruiter" class="text-primary" style="margin-left:5px;font-size: 14px"><q-icon name="info"></q-icon> Required if also Recruiter</span>
          </q-item-tile>
        </q-item-main>
        <q-item-side>
          <q-checkbox :disable="isRecruiter" :value="isAffiliate" @input="(value) => { updateAffiliateForm({ field: 'ACTIVE_IND', value }); setForm(value);  }" />
        </q-item-side>
      </q-item>      
      <q-item tag="label" separator v-if="$p(['ADMIN','MANAGER'],'or')">
        <q-item-side>
          <q-icon size="30px" color="primary" name="fa fa-user-plus"></q-icon>
        </q-item-side>
        <q-item-main>
          <q-item-tile title>Recruiter</q-item-tile>
        </q-item-main>
        <q-item-side>
          <q-checkbox :value="isRecruiter" @input="(value) => { updateRecruiterForm({ field: 'ACTIVE_IND', value }); updateAffiliateForm({ field: 'ACTIVE_IND', value }); setForm(value); }" />
        </q-item-side>
      </q-item>
      <q-item tag="label" separator v-if="$p(['ADMIN'])">
        <q-item-side>
          <q-icon size="30px" color="primary" name="fa fa-users"></q-icon>
        </q-item-side>
        <q-item-main>
          <q-item-tile title>Manager</q-item-tile>
        </q-item-main>
        <q-item-side>
          <q-checkbox :value="isManager" @input="(value) => { updateManagerForm({ field: 'ACTIVE_IND', value }); setForm(value); }" />
        </q-item-side>
      </q-item>
      <q-item tag="label" separator v-if="$p(['ADMIN'])">
        <q-item-side>
          <q-icon size="30px" color="primary" name="fa fa-magic"></q-icon>
        </q-item-side>
        <q-item-main>
          <q-item-tile title>Administrator</q-item-tile>
          <q-item-tile sublabel>This user has access to everything.</q-item-tile>
        </q-item-main>
        <q-item-side>
          <q-checkbox :value="isAdministrator" @input="(value) => { updateAdministratorForm({ field: 'ACTIVE_IND', value }); setForm(value);  }" />
        </q-item-side>
      </q-item>
    </q-list>
  </div>
</div>
</template>

<style lang="stylus" >
.center {
  max-width: 600px;
  margin: 0 auto;
}
</style>